import React from "react";
import { useNavigate } from "react-router-dom";
import {
  useGenerateBalanceSheetReport,
  useGenerateProfitLossReport,
} from "http-hooks/salebill/useSalebill";
import {
  getDocumentUrls,
  getDocumentViewerRoute,
} from "utils/documentUrlHelper";

const STATEMENTS = {
  balanceSheet: {
    title: "Balance Sheet",
    description:
      "Generate the balance sheet for the current financial year.",
    documentNumber: "BS",
  },
  profitLoss: {
    title: "Profit & Loss Statement",
    description:
      "Generate the profit and loss statement for the current financial year.",
    documentNumber: "PL",
  },
};

export default function FinancialStatement({ statementType }) {
  const navigate = useNavigate();
  const balanceSheetMutation = useGenerateBalanceSheetReport();
  const profitLossMutation = useGenerateProfitLossReport();
  const statement = STATEMENTS[statementType];
  const mutation =
    statementType === "balanceSheet"
      ? balanceSheetMutation
      : profitLossMutation;

  const handleGenerate = async () => {
    try {
      const data = await mutation.mutateAsync();
      const { htmlUrl, pdfUrl } = getDocumentUrls(data);
      const route = getDocumentViewerRoute(statementType, {
        htmlUrl,
        pdfUrl,
        documentNumber: statement.documentNumber,
        documentType: statement.title,
      });

      navigate(route);
    } catch (error) {
      console.error(`Error generating ${statement.title}:`, error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            {statement.title}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {statement.description}
          </p>
        </div>
      </div>

      <div className="mt-8">
        <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
          <div className="px-4 py-6 text-sm text-gray-700 sm:p-8">
            The report includes opening balances and all ledger activity through
            the current financial year end.
          </div>
          <div className="flex items-center justify-end border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
              type="button"
              onClick={handleGenerate}
              disabled={mutation.isPending}
              className="rounded-md bg-indigo-600 px-8 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {mutation.isPending ? "Generating..." : "Generate Report"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
